<!-- Search Overlay Background -->
<div
  class="search-overlay"
  [ngClass]="{ visible: showResults() }"
  (click)="clearSearch($event)"
></div>

<div
  class="search-wrapper"
  [ngClass]="{ expanded: showResults() }"
  style="border-bottom: none; margin-bottom: 0"
>
  <div class="relative w-full max-w-md mx-auto">
    <!-- Search Container with Shadow -->
    <div
      #searchContainer
      class="flex items-center w-full bg-white rounded-full shadow-sm border overflow-hidden transition-all duration-300 ease-in-out search-container"
      [ngClass]="{
        'border-amber-400 shadow-xl transform scale-105': isActive(),
        'border-gray-200': !isActive()
      }"
      (click)="toggleActive($event)"
    >
      <!-- Search Icon -->
      <div class="pl-4 pr-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>

      <!-- Search Input -->
      <input
        #searchInput
        type="text"
        [ngModel]="searchTerm()"
        (input)="onSearchInput($event)"
        placeholder="Buscar restaurantes, comidas, productos..."
        class="w-full py-3 px-2 text-gray-700 focus:outline-none text-sm"
      />

      <!-- Clear Button (shows when active) -->
      @if (isActive() && searchTerm()) {
      <div class="pr-2">
        <button
          class="p-1 rounded-full hover:bg-gray-100 transition-colors duration-200"
          (click)="clearSearch($event)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400 hover:text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      }

      <!-- Filter Button -->
      <button
        class="px-4 py-2 border-l border-gray-200 flex items-center justify-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
          />
        </svg>
      </button>
    </div>
  </div>

  <!-- Loading Indicator -->
  @if (isLoading()) {
  <div class="absolute z-50 w-full mt-2 flex justify-center">
    <div
      class="bg-white rounded-lg shadow-xl border border-gray-200 p-4 text-center"
    >
      <div
        class="animate-spin rounded-full h-6 w-6 border-b-2 border-amber-500 mx-auto"
      ></div>
      <p class="text-sm text-gray-600 mt-2">Buscando...</p>
    </div>
  </div>
  }

  <!-- Search Results Dropdown -->
  <div
    class="results-container mt-0 w-full bg-white rounded-lg shadow-xl border border-gray-200 border-b-0"
    [ngClass]="{
      expanded: showResults()
    }"
    style="margin-bottom: -1px"
  >
    <!-- Back to Search Button (when showing establishment products) -->
    @if (showingEstablishmentProducts() && selectedEstablishment()) {
    <div
      class="px-4 py-2 bg-amber-50 border-b border-gray-200 flex items-center"
    >
      <button
        (click)="backToGeneralSearch()"
        class="flex items-center text-amber-600 hover:text-amber-800"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 mr-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
        <span class="text-xs">Volver a resultados</span>
      </button>
      <div class="ml-2 text-sm font-medium text-gray-900 flex items-center">
        <span class="mx-2">|</span>
        <img
          [src]="selectedEstablishment()?.picture_logo"
          class="w-6 h-6 object-cover rounded-full mr-2"
          (error)="onImageError($event)"
        />
        {{ selectedEstablishment()?.name_restaurant }}
      </div>
    </div>
    }

    <!-- Establishments Section -->
    @if (establishments().length > 0 && !showingEstablishmentProducts()) {
    <div>
      <div class="px-4 py-2 border-b border-gray-200">
        <h3 class="text-md font-semibold text-gray-500 tracking-wider">
          <i class="fa-solid fa-store"></i>
          Establecimientos
          <span class="text-xs">({{ establishments().length }})</span>
        </h3>
      </div>
      <div class="flex flex-wrap justify-evenly gap-3 mt-6">
        @for (establishment of establishments(); track establishment) {
        <div
          class="w-full mx-2 md:mx-0 md:w-[340px] bg-white border border-gray-200 cursor-pointer rounded p-[12px] hover:scale-105 hover:bg-gray-100"
          (click)="
            navigateToProducts(
              establishment.id_restaurant,
              establishment.name_restaurant
            )
          "
        >
          <div class="hidden md:block md:relative">
            <img
              [src]="establishment.picture_logo"
              class="w-full h-[90px] object-cover rounded mr-3"
              (error)="onImageError($event)"
            />
            <div class="absolute top-1 left-1">
              @if(establishment.isOpen) {
              <div
                class="bg-emerald-500 text-green-800 p-1 rounded-full px-2 text-xs"
              >
                Abierto
              </div>
              }@else {
              <div
                class="bg-rose-400 text-red-800 p-1 rounded-full px-2 text-xs"
              >
                Cerrado
              </div>
              }
            </div>
          </div>
          <div class="hidden md:block w-full border-b border-gray-200"></div>
          <div class="flex justify-between items-center md:mt-2">
            <div class="flex">
              <img
                [src]="establishment.picture_logo"
                class="block md:hidden w-16 h-16 object-cover rounded mr-3"
                (error)="onImageError($event)"
              />
              <div>
                <div class="text-sm font-medium text-gray-600 mt-2">
                  {{ establishment.name_restaurant }}
                </div>
                <div class="text-xs font-medium my-2 text-gray-600">
                  <i class="fa fa-location-dot"></i>
                  {{ establishment.truncateAddress }}
                </div>
              </div>
            </div>
            <div>
              <div class="text-xs font-medium text-gray-600">
                <i class="fa-regular fa-clock"></i>
                {{ establishment.truncateCierre }}
              </div>
              <div class="block md:hidden mt-2">
                @if(establishment.isOpen) {
                <div
                  class="bg-emerald-500 text-center text-green-800 p-1 rounded-full px-2 text-xs"
                >
                  Abierto
                </div>
                }@else {
                <div
                  class="bg-rose-400 text-center text-red-800 p-1 rounded-full px-2 text-xs"
                >
                  Cerrado
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }

    <!-- Products Section -->
    @if (products().length > 0) {
    <div>
      <div class="px-4 py-2 bg-gray-50 border-b border-gray-200">
        <h3
          class="text-xs font-semibold text-gray-500 uppercase tracking-wider"
        >
          {{
            showingEstablishmentProducts()
              ? "Productos de " + selectedEstablishment()?.name_restaurant
              : "Productos"
          }}
        </h3>
      </div>
      @for (product of products(); track product) {
      <div
        class="px-4 py-2 hover:bg-gray-50 border rounded border-gray-200 m-3 cursor-pointer flex items-center"
        (click)="openProductModal(product)"
      >
        @if (product.pd_image) {
        <img
          [src]="product.pd_image"
          class="w-16 h-16 object-cover rounded mr-3"
          (error)="onImageError($event)"
        />
        }
        <div class="flex w-full justify-between items-center">
          <div>
            <div class="text-sm font-medium text-gray-900">
              {{ product.pd_name }}
            </div>
            <div class="text-xs text-gray-500">
              {{ product.pd_description}}
            </div>
            <div>

            </div>
          </div>
          <div class="text-xs text-gray-500">
            {{ product.pd_unit_price | currency }}
          </div>
        </div>
      </div>
      }
    </div>
    }

    <!-- No Results Message -->
    @if ( showResults() && establishments().length === 0 && products().length === 0 &&
    !isLoading() ) {
    <div class="p-4 text-center">
      <p class="text-sm text-gray-500">
        No se encontraron resultados para "{{ searchTerm() }}"
      </p>
    </div>
    }
  </div>
</div>

<!-- El modal ahora se muestra a nivel de aplicación -->
